export class IngestionPipelineRetiredAggregation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "outputId",
            "baseName": "outputId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "namespace",
            "baseName": "namespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "purge",
            "baseName": "purge",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "phase",
            "baseName": "phase",
            "type": "IngestionPipelineRetiredAggregationPhase",
            "format": ""
        },
        {
            "name": "retiredAt",
            "baseName": "retiredAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "teardownScheduledAt",
            "baseName": "teardownScheduledAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineRetiredAggregation.attributeTypeMap;
    }
    constructor() {
    }
}
